module.exports = __webpack_public_path__ + "img/Julia4.7a47bc8a.png";